import { cn } from "@/lib/utils";

interface RequiredFieldIndicatorProps {
  children: React.ReactNode;
  required?: boolean;
  className?: string;
}

export const RequiredFieldIndicator = ({ 
  children, 
  required = false,
  className 
}: RequiredFieldIndicatorProps) => {
  return (
    <span className={cn("flex items-center gap-1", className)}>
      {children}
      {required && (
        <span className="text-destructive font-medium" aria-label="required">*</span>
      )}
    </span>
  );
};

export const FormLegend = () => {
  return (
    <div className="flex items-center gap-4 text-sm text-muted-foreground bg-muted/50 px-4 py-2 rounded-lg border">
      <div className="flex items-center gap-1">
        <span className="text-destructive font-medium">*</span>
        <span>Required field</span>
      </div>
      <div className="h-4 w-px bg-border" />
      <div className="flex items-center gap-1">
        <span className="text-muted-foreground/70">No asterisk</span>
        <span>= Optional field</span>
      </div>
    </div>
  );
};
